import React from "react";
import { ATALogo } from "./ATALogo";
import { Sign } from "../sign-generator/Sign";
import { makeStyles } from "@fluentui/react-components";
import { ISignForm } from "../../interfaces/ISignForm";
import { UseFormWatch } from "react-hook-form";
type OrderConfirmationSnapshotProps = {
  logoRef: React.MutableRefObject<HTMLDivElement>;
  signRef: React.MutableRefObject<HTMLDivElement>;
  watch: UseFormWatch<ISignForm>;
};
const useStyles = makeStyles({
  hiddenPdfLogo: {
    position: "absolute",
    top: "-9999px",
    left: "-9999px",
    width: "fit-content",
    height: "fit-content",
    overflow: "hidden",
    pointerEvents: "none",
    opacity: "0",
  },
});
export const OrderConfirmationSnapshot = ({
  logoRef,
  signRef,
  watch,
}: OrderConfirmationSnapshotProps) => {
  const styles = useStyles();
  return (
    <div className={styles.hiddenPdfLogo}>
      <ATALogo logoRef={logoRef} />

      <Sign sign={watch()} signRef={signRef} modalPreview />
    </div>
  );
};
